import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "outlook",
  "use": "outlook-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"outlook\">\n  <polygon fill=\"#EB3C00\" points=\"2 15.7 2 4.6 12.24 1 18 2.8 18 17.2 12.24 19 2 15.7 12.24 16.6 12.24 4 5.52 5.2 5.52 14.2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol